<h3 i18n>Module list available</h3>

<div style="margin-bottom: 16px;">
  <mat-checkbox
    [ngModel]="isAllSelected()"
    [indeterminate]="isIndeterminate()"
    (change)="toggleSelectAll($event)">
    <span i18n>Select All</span>
  </mat-checkbox>
</div>

<mat-list role="list">
  @for (item of moduleList; track item.module_key) {

    <mat-list-item role="listitem">
      <mat-checkbox (change)="updateModule(item, $event)" [ngModel]="item.checked">
        {{ item.description }} ({{ item.module_key }})
      </mat-checkbox>

    </mat-list-item>
  }

</mat-list>


